import DialogTemplate from "./dialogTemplate";
import { colors } from "../../theme";
import { Container, Typography } from "@mui/material";
import styled from "styled-components";
import moment from "moment";

interface StyledDialogOptionProps {
    disabled?: boolean;
}

const UpcomingOfficeHoursDialog = (props: any) => {
    const { dataItems, allTerms, currentTerm } = props;

    const renderContent = () => {
        const futureTerms = allTerms.filter((e) => {
            return moment(e.startDate).isAfter(moment(currentTerm.endDate))
        });

        return (
            <Container>
                <DialogText>
                    <Typography variant="h5" sx={{ textAlign: 'left' }}>
                        You have office hours appointment in this upcoming terms.
                    </Typography>
                    {futureTerms.map((element, index) => {
                        const num = dataItems.filter((e) => {
                            return moment(e.startDate).isBetween(moment(element.startDate), moment(element.endDate));
                        }).length
                        return (
                            <StyledDialogOption disabled={false} >
                                <div>{element.code + " " + element.label.split(" ")[0]}</div>
                                <div>{num + " Appointment(s)"}</div>
                            </StyledDialogOption>
                        )
                    })}
                </DialogText>
            </Container>
        );
    };

    return (
        <DialogTemplate {...props} title={`Office Hours`} titleColor={colors.blue.main} renderContent={renderContent} />
    );
}

export default UpcomingOfficeHoursDialog;

const DialogText = styled.div`
    text-align: center;
    
    h5 {
        line-height: 1.5;
        font-weight: 500;
        padding-bottom: 10px;
    }
`;

const StyledDialogOption = styled.div<StyledDialogOptionProps>`
    border: 1px solid #EAEAEA;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 5px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    color: ${(props) => (props.disabled ? 'rgba(0, 0, 0, 0.26)' : '#000000')};
    justify-content: space-between;
    &:hover {
        border: ${(props) => (props.disabled ? '1px solid #EAEAEA' : '1px solid #007cde')};
    }
    
    div {
        display: inline-flex;
    }
`;
